import { gql } from '@apollo/client';

export const INSTRUCTOR_CREATE = gql`
    mutation createInstructor( $input: CreateInstructorInput! ) {
        createInstructor( input: $input ) {
            id
            companyId
            name
            description
            title
            emailAddress
            createdAt
            updatedAt
        }
    }
`;

export default INSTRUCTOR_CREATE;
